import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { poppins300, poppins400, poppins500 } from 'theme/common.style';
import WinnerPendingBannerImageVendor from 'assets/images/WinnerPendingBannerImageVendor.png';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { PUBLISH_WINNER } from 'constant/app.config';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import Swal from 'sweetalert2';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { datacontext } from 'modules/AppLayout/AppLayout';
import Loading from 'assets/images/loading.png';
import dayjs from 'dayjs';

const ConfirmTicIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38210_159899)">
        <path
          d="M5 12L10 17L20 7"
          stroke="#4898F8"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_38210_159899">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const WinnerPendingBannerAgent = (props) => {
  let {
    bannerDetails,
    isAgentDashboard,
    setOpenFromBannerNominateWinner,
    getListInfo,
    setRequestdeposit,
    setDepositdetails,
    isRequestDepositCompleted,
    AgentGroupCall,
  } = props;
  const theme = useTheme();
  const history = useHistory();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const [open, setOpen] = useState(false);

  let PropertyId = bannerDetails?.propertyId;

  const onPropertyClick = (propertyId) => {
    history.push({
      pathname: `dashboard/view-dashboard/${propertyId}`,
      state: {
        dashboardOpenBannerNominateWinnerPopup: true,
      },
    });
  };

  const address = bannerDetails?.propertyAddress;
  const buyerName = bannerDetails?.highestOfferBuyerName;
  const highestOffer = bannerDetails?.highestOffer;

  const winnerTime = bannerDetails?.winnerTime;

  const formattedDate = winnerTime
    ? dayjs(winnerTime).format('DD MMM YYYY')
    : '';

  const formattedTime = winnerTime ? dayjs(winnerTime).format('hh:mm A') : '';

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={8} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '10px' : '14px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                    marginTop: matchessm ? '0px' : '-10px',
                  }}
                >
                  {address}
                </Typography>

                <Stack direction={'row'} alignItems={'center'} spacing={0.6}>
                  <Typography
                    sx={{
                      fontSize: !matches450 ? '32px' : '20px',
                      fontWeight: 600,
                      color: '#FFF',
                      fontFamily: 'poppins',
                    }}
                  >
                    {' '}
                    🏆
                  </Typography>{' '}
                  <Typography
                    sx={{
                      fontSize: !matches450 ? '27px' : '18px',
                      fontWeight: 600,
                      color: '#FFF',
                      fontFamily: 'poppins',
                    }}
                  >
                    Winner Pending – Auto-Finalise or Nominate Winner Now!
                  </Typography>
                </Stack>

                <Typography
                  sx={{
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '16px',
                    marginTop: matchessm ? '0px' : '15px',
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  The campaign for &nbsp;
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {address}
                  </span>
                  &nbsp; has ended.&nbsp;
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {' '}
                    {buyerName}
                  </span>{' '}
                  &nbsp; submitted the highest offer of
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {' '}
                    {highestOffer}
                  </span>{' '}
                  and will be automatically nominated as the winner at
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {' '}
                    {formattedDate ?? '-'} | {formattedTime ?? '-'}
                  </span>{' '}
                  <br />
                  Want to stay in control? Nominate the winner now and
                  fast-track the next steps.
                </Typography>

                <Box
                  display="flex"
                  alignItems="center"
                  mt={matchessm ? 1 : 2.5}
                >
                  <Button
                    onClick={() => {
                      if (isAgentDashboard) {
                        onPropertyClick(PropertyId);
                      } else {
                        handleOpen();
                      }
                    }}
                    startIcon={<ConfirmTicIcon />}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: '#FFF',
                      color: '#2184FD',
                      fontWeight: 400,
                      fontFamily: 'poppins',
                      '&:hover': {
                        bgcolor: '#FFFFFF',
                        color: '#2184FD',
                      },
                    }}
                  >
                    Nominate Winner
                  </Button>
                  <NominateWinnerPopupBanner
                    open={open}
                    address={address}
                    buyerName={buyerName}
                    setOpen={setOpen}
                    bannerDetails={bannerDetails}
                    getListInfo={getListInfo}
                    setDepositdetails={setDepositdetails}
                    setRequestdeposit={setRequestdeposit}
                    isRequestDepositCompleted={isRequestDepositCompleted}
                    AgentGroupCall={AgentGroupCall}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={WinnerPendingBannerImageVendor}
                alt="WinnerPendingBannerImageVendor"
                style={{ objectFit: 'contain', height: '275px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

const NominateWinnerPopupBanner = (props) => {
  const {
    open,
    address,
    buyerName,
    setOpen,
    bannerDetails,
    getListInfo,
    setDepositdetails,
    setRequestdeposit,
    isRequestDepositCompleted,
    AgentGroupCall,
  } = props;

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const { setWinerPublishdMoveToEnded, setwinnerPopper } =
    useContext(PropertyContext);

  const currentStage = bannerDetails?.stage === 'ST2' ? 2 : 1;

  const offerUniqueIdBanner = bannerDetails?.highestOfferUniqueId;

  const history = useHistory();
  const location = useLocation();
  const { dashboardOpenBannerNominateWinnerPopup } = location?.state || {};
  useEffect(() => {
    if (dashboardOpenBannerNominateWinnerPopup) {
      setOpen(true);
    }
  }, [dashboardOpenBannerNominateWinnerPopup]);

  const handleClose = () => {
    setOpen(!open);
    history.push({
      pathname: history.location.pathname,
      state: { dashboardOpenBannerNominateWinnerPopup: false },
    });
  };
  const { bannerApiTrigger } = useContext(datacontext);

  const [publishLoader, setPublishLoader] = useState(false);

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForST2EndedBuyerAck))
      Moxoseparationinlisting(
        'dataForST2EndedBuyerAck',
        res?.data?.dataForST2EndedBuyerAck
      ); //1
    if (isNotEmptyArray(res?.data?.dataForST2EndedVendorAck))
      Moxoseparationinlisting(
        'dataForST2EndedVendorAck',
        res?.data?.dataForST2EndedVendorAck
      ); //2
    if (isNotEmptyArray(res?.data?.dataForWinnerVendorAck))
      Moxoseparationinlisting(
        'dataForWinnerVendorAck',
        res?.data?.dataForWinnerVendorAck
      ); //3
    if (isNotEmptyArray(res?.data?.dataForWinnerBuyerAck))
      Moxoseparationinlisting(
        'dataForWinnerBuyerAck',
        res?.data?.dataForWinnerBuyerAck
      ); //4
  };

  const publishwinnerfun = (offerUniqueId) => {
    setPublishLoader(true);
    const params = {
      offerUniqueId: offerUniqueId,
    };
    postApiCall(PUBLISH_WINNER, params)
      .then((res) => {
        if (res?.data?.status == 1) {
          bannerApiTrigger();
          setPublishLoader(false);

          getListInfo();
          AgentGroupCall();
          moxoapis(res);
          setWinerPublishdMoveToEnded(true);
          setwinnerPopper(true);
          setTimeout(() => {
            Swal.fire({
              icon: 'success',
              title: res?.data?.heading ? res?.data?.heading : 'Success',
              html: `${
                bannerDetails?.timerStatus !== 'End'
                  ? (bannerDetails?.stage === 'ST1' ? 'Stage 1' : 'Stage 2') +
                    ' has now ended. '
                  : ''
              }<b style="font-family: Poppins; font-weight: 550; color: #666666;">
  ${buyerName}
</b> has been nominated as the Winner.`,
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: isRequestDepositCompleted
                ? 'View deposit details'
                : 'Request Deposit',
              cancelButtonText: isRequestDepositCompleted ? 'Close' : 'Close',
              reverseButtons: true,
            }).then(({ isConfirmed, isDismissed }) => {
              if (isConfirmed) {
                if (isRequestDepositCompleted) {
                  setDepositdetails(true);
                  return;
                } else {
                  setRequestdeposit(true);
                  return;
                }
              } else if (isDismissed) {
                return;
              }
            });
          }, 6000);
        } else {
          Swal.fire({
            icon: 'error',
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            confirmButtonText: 'Close',
          });
          setPublishLoader(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred while nominating the winner. Please try again later.',
        });
        setPublishLoader(false);
      })
      .finally(() => {
        history.push({
          pathname: history.location.pathname,
          state: { dashboardOpenBannerNominateWinnerPopup: false },
        });
        setPublishLoader(false);
        setOpen(!open);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(!open)}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '95%' : '400px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          padding: matchessm ? '30px 20px' : '30px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid item xs={12}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
            }}
          >
            {'   '}
            {address}
            &nbsp;
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          display={'flex'}
          alignItems={'center'}
          padding={'12px 0px 15px 0'}
        >
          <Pendingwarning />
          <Typography
            sx={{
              ...poppins500,
              fontSize: matchessm ? '16px' : '24px',
              paddingLeft: '12px',
            }}
          >
            Nominate Winner
          </Typography>
        </Grid>
        <Grid item xs={12} textAlign={'left'} paddingTop={'10px'}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
              width: '100%',
            }}
            whiteSpace={'wrap'}
          >
            <>
              Do you like to nominate {''}
              <b
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 550,
                  color: '#666666',
                }}
              >
                {buyerName}
              </b>{' '}
              as a winner?{' '}
            </>
          </Typography>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent={'flex-end'}
          gap={matchessm ? '5px' : 2}
          marginTop={matchessm ? '15px' : 5}
          alignItems={'center'}
        >
          <Grid item>
            <Button
              disabled={publishLoader}
              variant="outlined"
              style={{
                padding: matchessm ? '6px 18px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px',
            }}
          >
            <Button
              disabled={publishLoader}
              variant="outlined"
              onClick={() => {
                publishwinnerfun(offerUniqueIdBanner);
              }}
              style={{
                padding: matchessm ? '7px 17px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'none',
              }}
            >
              Nominate
            </Button>
            {publishLoader && (
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default WinnerPendingBannerAgent;
